<template>
  <div>
    <header class="px-[52px] pb-[52px]">
      <img
        src="/playmaxx-logo-new.svg"
        alt="PlayMAXX"
        class="object-contain mt-[80px] w-full lg:w-[514px] mx-auto z-10 relative"
      />
    </header>
    <div
      class="pt-[40px] px-[15px] lg:px-[30px] mx-auto relative w-full lg:w-[395px] space-y-[25px] flex flex-col items-center text-center"
    >
      <h1 class="text-6xl font-bold text-white">
        {{ error.statusCode || 404 }}
      </h1>
      <p class="text-white">
        {{
          error.statusCode === 404
            ? "We couldn't find the page you were looking for."
            : "Something went wrong."
        }}
      </p>
      <button
        type="button"
        class="btn bg-playmaxx !text-pmblack focus:bg-playmaxxfocus transition duration-300 focus:!text-white"
        @click="onHome"
      >
        Back to home
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  error: { statusCode?: number; statusMessage?: string; message?: string };
}>();

const onHome = () => clearError({ redirect: "/" });
</script>
